var _circle, _path, _path2, _path3, _circle2, _circle3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFtmlpm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint0_linear_6771_37079)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 14L5.375 11.625V9.37499C5.37491 7.62053 6.875 3.875 11.5 3.875C16.125 3.875 17.5 7.6994 17.5 10.875C17.5 13.175 19.25 13.75 20.125 13.75C20 14.2917 19.475 15.375 18.375 15.375C17.275 15.375 16.8751 16.25 16.875 16.75C16.875 17.375 16.7501 18.625 15.75 18.625C14.4938 18.625 13.8751 18.875 13.7501 19.375C13.6251 19.875 13.5001 20.375 12.0001 20.375C10.5001 20.375 9.375 19.75 7.875 18.625C6.675 17.725 5.375 15.5 5.375 14Z",
    fill: "#B5D2D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0788 20.2319C8.49122 18.3566 7.12495 15.4905 7.125 11.8749C7.12504 8.25456 7.62372 6.25504 11.1097 3.88403C6.79017 4.08816 5.37491 7.67078 5.375 9.37491C5.37507 10.7499 5.375 11.6249 5.375 11.6249L5.375 13.9999C5.375 15.4999 6.675 17.7249 7.875 18.6249C9.375 19.7499 10.5001 20.3749 12.0001 20.3749C12.4907 20.3749 12.8343 20.3214 13.0788 20.2319Z",
    fill: "#9EB9BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2215 15.1218C18.0875 14.9874 15.875 14.2198 15.875 10.6251C15.875 6.25014 13.375 4.37515 12 4.00015V3.89062C16.2248 4.1572 17.5 7.817 17.5 10.8751C17.5 13.1751 19.25 13.7501 20.125 13.7501C20.0379 14.1276 19.7565 14.7682 19.2215 15.1218Z",
    fill: "#728782"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.75,
    cy: 9,
    r: 2,
    fill: "#2B454C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 9,
    r: 2,
    fill: "#2B454C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9C7.5 9.69036 8.05964 10.25 8.75 10.25V7.75C8.05964 7.75 7.5 8.30964 7.5 9Z",
    fill: "#46D97F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9C12.75 9.69036 13.3096 10.25 14 10.25V7.75C13.3096 7.75 12.75 8.30964 12.75 9Z",
    fill: "#65D9DD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51022 5.80801C7.50948 4.59639 9.11074 3.625 11.5 3.625C13.8937 3.625 15.4717 4.62079 16.441 6.04338C17.4008 7.45217 17.75 9.25754 17.75 10.875C17.75 11.9527 18.1557 12.5974 18.6392 12.9787C19.1338 13.3688 19.7324 13.5 20.125 13.5H20.4393L20.3686 13.8062C20.2989 14.1081 20.1213 14.5523 19.8071 14.9264C19.4889 15.3052 19.0178 15.625 18.375 15.625C17.9064 15.625 17.6002 15.8223 17.4059 16.0595C17.2031 16.3071 17.125 16.5954 17.125 16.75C17.125 17.0316 17.048 17.5345 16.8573 17.9744C16.6729 18.3997 16.3305 18.875 15.75 18.875C15.2091 18.875 14.768 18.9543 14.4584 19.0749C14.1335 19.2015 14.0148 19.3468 13.9926 19.4356C13.9284 19.6923 13.7755 19.9966 13.4525 20.2344C13.1306 20.4713 12.6631 20.625 12.0001 20.625C10.5425 20.625 9.23806 19.9598 7.725 18.825C7.08934 18.3483 6.44342 17.553 5.95688 16.6844C5.47146 15.8177 5.125 14.843 5.125 14V9.375C5.125 9.375 5.125 9.37499 5.125 9.37499C5.12495 8.44067 5.51954 7.00922 6.51022 5.80801ZM6.89596 6.12614C5.98037 7.2363 5.62496 8.55483 5.625 9.37498V9.37499V14C5.625 14.7229 5.92853 15.6106 6.39311 16.44C6.85658 17.2674 7.46066 18.0017 8.025 18.425C9.51194 19.5402 10.7075 20.125 12.0001 20.125C12.5869 20.125 12.9418 19.9894 13.1561 19.8317C13.3692 19.6748 13.4663 19.4791 13.5075 19.3144C13.5907 18.9818 13.9095 18.7521 14.2769 18.609C14.6597 18.46 15.1658 18.375 15.75 18.375C16.0106 18.375 16.2306 18.1628 16.3985 17.7756C16.56 17.403 16.625 16.9684 16.625 16.75C16.625 16.474 16.7469 16.0749 17.0191 15.7426C17.2998 15.4 17.7436 15.125 18.375 15.125C18.8322 15.125 19.1736 14.9031 19.4242 14.6048C19.5915 14.4056 19.7126 14.1782 19.7916 13.9776C19.3461 13.9199 18.8021 13.7439 18.3296 13.3713C17.7193 12.8901 17.25 12.0973 17.25 10.875C17.25 9.31686 16.9117 7.62223 16.0278 6.32492C15.1533 5.04141 13.7313 4.125 11.5 4.125C9.26425 4.125 7.80296 5.02638 6.89596 6.12614Z",
    fill: "#000E1D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6771_37079",
    x1: 0,
    y1: 12,
    x2: 24,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B95B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26A478"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtmlpm);
export default __webpack_public_path__ + "static/media/ftmlpm.90bd1a9da755fbbff2121941192151ef.svg";
export { ForwardRef as ReactComponent };